// Below this width both side panels can't be open without covering the map.
export const NARROW_SCREEN = "(max-width: 1099px)";
// Phones: the right panel becomes a sheet along the bottom.
export const PHONE_SCREEN = "(max-width: 599px)";
// From here the map bar fits on one line beside the right panel.
export const WIDE_SCREEN = "(min-width: 1200px)";

// The panels slim scrollbar.
export const THIN_SCROLLBAR = {
  scrollbarWidth: "thin",
  scrollbarColor: "rgba(var(--primary-rgb), 0.2) transparent",
  "&::-webkit-scrollbar": { width: "6px" },
  "&::-webkit-scrollbar-track": { background: "transparent" },
  "&::-webkit-scrollbar-thumb": {
    background: "rgba(var(--primary-rgb), 0.2)",
    borderRadius: "10px",
  },
  "&::-webkit-scrollbar-thumb:hover": {
    background: "rgba(var(--primary-rgb), 0.4)",
  },
};
